var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var OperationalSubTaskTypes;
(function (OperationalSubTaskTypes) {
    OperationalSubTaskTypes["VERIFY_DOMAIN"] = "verify-domain";
    OperationalSubTaskTypes["ADD_ORGANIZATION"] = "add-organization";
    OperationalSubTaskTypes["BRAND_ORGANIZATION"] = "brand-organization";
    OperationalSubTaskTypes["UPDATE_MASTER_LANGUAGE"] = "update-master-language";
    OperationalSubTaskTypes["APPROVE_NEW_ORGANIZATION"] = "approve-new-organization";
    OperationalSubTaskTypes["SEND_CHANNEL_SHARE_MESSAGE_TO_EXISTING_USER"] = "send-channel-share-message-to-existing-user";
    OperationalSubTaskTypes["SEND_CHANNEL_SHARE_MESSAGE_TO_NEW_USER"] = "send-channel-share-message-to-new-user";
    OperationalSubTaskTypes["REGISTER_ACCOUNT"] = "register-account";
    OperationalSubTaskTypes["LOGIN_FOR_FIRST_TIME"] = "login-for-first-time";
    OperationalSubTaskTypes["VERIFY_VIDEO_PRODUCTION_ORDER"] = "verify-video-production-order";
    OperationalSubTaskTypes["PRODUCE_VIDEO_PRODUCTION_ORDER"] = "produce-video-production-order";
    OperationalSubTaskTypes["REVIEW_AND_APPROVE_VIDEO_PRODUCTION_ORDER"] = "review-and-approve-video-production-order";
    OperationalSubTaskTypes["SUPPORT_TICKET"] = "support-ticket";
    OperationalSubTaskTypes["UPDATE_CRM_PROFILE"] = "update-crm-profile";
    OperationalSubTaskTypes["UPLOAD_VIDEO"] = "upload-video";
    OperationalSubTaskTypes["ADD_PLAYLIST_TO_CHANNEL"] = "add-playlist-to-channel";
})(OperationalSubTaskTypes || (OperationalSubTaskTypes = {}));
export var GovernanceSubTaskTypes;
(function (GovernanceSubTaskTypes) {
    GovernanceSubTaskTypes["ASSIGN_CHANNEL_OWNER"] = "assign-channel-owner";
})(GovernanceSubTaskTypes || (GovernanceSubTaskTypes = {}));
export default __assign(__assign({}, OperationalSubTaskTypes), GovernanceSubTaskTypes);



//////////////////
// WEBPACK FOOTER
// ./src/enums/TaskSubTypes.ts
// module id = 797
// module chunks = 81